<template>
  <PageLayout>
    <template #headerTitle>Paramètres des coupons</template>

    <!-- HEADER WITH BACK BUTTON -->
    <div class="flex justify-between items-center mb-6">
      <button
        class="flex items-center gap-2 text-gray-600 hover:text-gray-900"
        @click="$router.push('/coupons')"
      >
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
        Retour aux coupons
      </button>
      <div v-show="hasChanges" class="flex gap-3">
        <button
          class="px-6 py-2 rounded-xl bg-gray-300 text-gray-700"
          @click="reset"
        >
          Annuler
        </button>
        <button
          class="px-6 py-2 rounded-xl bg-primary-600 text-white"
          @click="save"
        >
          Sauvegarder
        </button>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="bg-slate-100 rounded-3xl p-6 max-w-2xl">
      <div class="space-y-6">
        <!-- SUBSCRIPTION PRICE -->
        <div>
          <label class="block mb-2 text-sm font-medium">
            Prix de l'abonnement premium (XOF)
          </label>
          <input
            v-model.number="form.couponSubscriptionPrice"
            type="number"
            min="0"
            step="100"
            class="inputComponent w-full"
            placeholder="0"
          />
          <p class="text-xs text-gray-500 mt-2">
            Prix que les clients doivent payer pour accéder aux coupons premium
          </p>
        </div>

        

        <!-- ENABLING TEXT -->
        <div>
          <label class="block mb-2 text-sm font-medium">
            Texte d'activation VIP
          </label>
          <textarea
            v-model="form.vipCouponsEnablingText"
            class="inputComponent w-full h-24 resize-none"
            placeholder="Expliquez comment activer les coupons VIP..."
          ></textarea>
          <p class="text-xs text-gray-500 mt-2">
            Message affiché pour expliquer l'activation des coupons VIP
          </p>
        </div>
      </div>
    </div>
  </PageLayout>
</template>

<script>
export default {
  name: 'CouponSettingsPage',

  data() {
    return {
      form: {
        couponSubscriptionPrice: 0,
        vipAmountRequired: 0,
        vipCouponsAllowed: false,
        vipCouponsEnablingText: '',
        couponBannerPicture: ''
      }
    };
  },

  computed: {
    settings() {
      return this.$stores.coupon?.state?.list_all?.settings;
    },
    hasChanges() {
      if (!this.settings) return false;
      return (
        this.form.couponSubscriptionPrice !==
          this.settings.couponSubscriptionPrice ||
        this.form.vipAmountRequired !== this.settings.vipAmountRequired ||
        this.form.vipCouponsAllowed !== this.settings.vipCouponsAllowed ||
        this.form.vipCouponsEnablingText !==
          this.settings.vipCouponsEnablingText ||
        this.form.couponBannerPicture !== this.settings.couponBannerPicture
      );
    }
  },

  watch: {
    settings: {
      immediate: true,
      handler(newSettings) {
        if (newSettings) {
          this.form = {
            couponSubscriptionPrice: newSettings.couponSubscriptionPrice || 0,
            vipAmountRequired: newSettings.vipAmountRequired || 0,
            vipCouponsAllowed: newSettings.vipCouponsAllowed || false,
            vipCouponsEnablingText: newSettings.vipCouponsEnablingText || '',
            couponBannerPicture: newSettings.couponBannerPicture || ''
          };
        }
      }
    }
  },

  methods: {
    save() {
      if (!this.hasChanges) return;
      this.$bus.emit(this.$constants.EVENTS.COUPON.UPDATE_SETTINGS, this.form);
    },

    reset() {
      if (this.settings) {
        this.form = {
          couponSubscriptionPrice: this.settings.couponSubscriptionPrice || 0,
          vipAmountRequired: this.settings.vipAmountRequired || 0,
          vipCouponsAllowed: this.settings.vipCouponsAllowed || false,
          vipCouponsEnablingText: this.settings.vipCouponsEnablingText || '',
          couponBannerPicture: this.settings.couponBannerPicture || ''
        };
      }
    }
  }
};
</script>
